module.exports = __webpack_public_path__ + "static/media/minus.46759735.svg";